import { storage } from '../config/firebase';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';

export const uploadFile = async (file, path = 'uploads/') => {
  try {
    const fullPath = `${path}${file.name}`;
    const storageRef = ref(storage, fullPath);
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return { downloadURL, fileName: fullPath }; // This URL can be used to view or download the file
  } catch (error) {
    console.error('Upload failed', error);
    throw error; // Re-throw to handle in your UI
  }
};

export const downloadFile = async (path) => {
  try {
    const storageRef = ref(storage, path);
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL; // Use this URL to download or display the file
  } catch (error) {
    console.error('Download failed', error);
    throw error;
  }
};
